import { Anchor, Text } from '@mantine/core';
import { GradientBorderedCard } from 'src/common/components/card/GradientBorderedCard';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  count: number;
  onIdentify: () => void;
};

export function UnidentifiedSpeakersNotice({ count, onIdentify }: Props) {
  return (
    <GradientBorderedCard>
      <Text size="sm" fw={FONT_WEIGHTS.semibold}>
        {count === 1 ? '1 speaker is' : `${count} speakers are`} still unidentified, so the meeting
        note may attribute statements to the wrong person.{' '}
        <Anchor component="button" type="button" inherit c="brand.8" onClick={onIdentify}>
          Identify speakers
        </Anchor>{' '}
        first, or generate now and regenerate the note once they&apos;re identified.
      </Text>
    </GradientBorderedCard>
  );
}
